import styled from "styled-components";
import { motion, useScroll, useSpring, useTransform } from "framer-motion";
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";

const Portfolio = ({ productId, item, hideButton = false }) => {
  const navigate = useNavigate();
  const ref = useRef();
  const { scrollYProgress } = useScroll({
    target: ref,
  });

  const handleButtonClick = (info) => {
    if (hideButton || info.title === null) {
      return null;
    }
    return navigate(`/product/${productId}/${info.id}`);
  };

  return (
    <Container>
      <PortfolioContainer>
        {item.portfolioInfo.slice(0, 4).map((info) => (
          <PrimaryWrapper key={info.id}>
            {info.image && (
              <ImageContainer ref={ref} onClick={() => handleButtonClick(info)}>
                <DarkLayer />
                <Image src={`/img/${info.image}`} />
                <TextContainer>
                  <Title>{info.title}</Title>
                  <FooterContainer>
                    {/* <Description>{info.desc}</Description> */}
                    {!hideButton && info.title !== null && (
                      <Button onClick={() => handleButtonClick(info)}>
                        VIEW MORE
                      </Button>
                    )}
                  </FooterContainer>
                </TextContainer>
              </ImageContainer>
            )}
          </PrimaryWrapper>
        ))}
      </PortfolioContainer>

      <SecondaryLayerContainer>
        {item.portfolioInfo.slice(4).map((info) => (
          <SecondaryWrapper key={info.id}>
            {info?.image && (
              <ImageContainer ref={ref} onClick={() => handleButtonClick(info)}>
                <DarkLayer />
                <Image src={`/img/${info?.image}`} />
                <TextContainer>
                  <Title>{info.title}</Title>
                  <FooterContainer>
                    {/* <Description>{info.desc}</Description> */}
                    {!hideButton && info.title !== null && (
                      <Button onClick={() => handleButtonClick(info)}>
                        VIEW MORE
                      </Button>
                    )}
                  </FooterContainer>
                </TextContainer>
              </ImageContainer>
            )}
          </SecondaryWrapper>
        ))}
      </SecondaryLayerContainer>
    </Container>
  );
};

export default Portfolio;

const Container = styled.div`
  scroll-snap-align: center;
  padding-left: 180px;
  padding-right: 180px;
  overflow: hidden;
  height: 100vh;
  @media (max-width: 768px) {
    padding: 0px 0px 0px 0px;
  }
`;

const PortfolioContainer = styled.div`
  display: flex;
  gap: 20px;
  height: 50%;
  padding: 20px;
  padding-top: 40px;
  padding-bottom: 10px;
  -webkit-tap-highlight-color: transparent;
  @media (max-width: 768px) {
    padding-top: 0px;
    padding-bottom: 10px;
    gap: 10px;
  }
`;

const SecondaryLayerContainer = styled.div`
  display: flex;
  gap: 20px;
  height: 50%;
  padding: 20px;
  padding-top: 10px;
  -webkit-tap-highlight-color: transparent;
  @media (max-width: 768px) {
    padding-top: 10px;
    padding-bottom: 0px;
    gap: 10px;
  }
`;

const PrimaryWrapper = styled.div`
  height: 100%;
  width: 25%;
  display: flex;
  align-items: end;
  /* justify-content: center; */
`;

const SecondaryWrapper = styled.div`
  height: 100%;
  width: 25%;
  display: flex;
  align-items: start;
  justify-content: center;
`;

const ImageContainer = styled.div`
  height: 65%;
  width: 100%;
  position: relative;
  cursor: pointer;
  @media (max-width: 768px) {
    height: 50%;
  }
`;

const DarkLayer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  @media (max-width: 768px) {
  }
`;

const TextContainer = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Title = styled.h2`
  top: 10;
  font-size: 20px;
  text-align: center;
  color: white;
  font-family: "Kestrel";
  background-color: #363737;
  opacity: 0.8;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Description = styled.p`
  font-size: 18px;
  width: 100%;
  align-self: flex-end;
  color: white;
`;

const Button = styled.button`
  margin-bottom: 10px;
  opacity: 1;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
  border-width: 0px;
  @media (max-width: 768px) {
    font-size: 8px;
  }
`;
